import { webInstance } from "../../api";

export default {
    get() {
        return webInstance.get("/cart");
    },
    add(data) {
        return webInstance.put(`/cart/${data.stock_line_id}`, data);
    },
    persist(items) {
        return webInstance.post("/cart", { items });
    },
    applyCoupon(code, email) {
        return webInstance.post(`/cart/coupon/${code}`, email);
    },
    removeCoupon() {
        return webInstance.delete("/cart/coupon/remove");
    },
};
